import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpError } from "app/helpers/httpError";
import { HttpRequestHelper } from "app/helpers/httpRequestHelper";
import { ExposedCreateAzureEnvironmentReservationReq } from "app/interfaces/requests/Exposed/exposedCreateAzureEnvironmentReservationReq";
import { ExposedListAzureEnvironmentReservationRes } from "app/interfaces/responses/Exposed/exposedListAzureEnvironmentReservationRes";
import { HttpStatus } from "app/interfaces/support/status/httpStatus";
import { AlertsService } from "app/services/system/alerts/alerts.service";
import { LoaderService } from "app/services/system/loader/loader.service";
import { environment } from "environments/environment";
import { catchError, finalize, map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class AzureEnvironmentService {
    private httpRequestHelper = new HttpRequestHelper();

    constructor(
            private http: HttpClient,
            private loaderService: LoaderService,
            private alertsService: AlertsService,
            private router: Router
        ) {}
        
    public createAzureEnvironmentReservation(req: ExposedCreateAzureEnvironmentReservationReq): Observable<number> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Skrái frátekt');

        return this.http
            .post<HttpStatus<number>>(`${environment.localApi}azuredevops/environments/reservations`, req, this.httpRequestHelper.getRequestOptionsAuth())
            .pipe(
                map((res: HttpStatus<number>) => res.returnItem),
                catchError((error) => {
                    HttpError(this.alertsService, this.router, error, '', '', '', '');
                    throw error;
                }),
                finalize(() => {
                    this.loaderService.changeActiveLoaders(-1);
                })
            );
    }

    public listAzureEnvironmentReservations(environmentName: string): Observable<ExposedListAzureEnvironmentReservationRes[]> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki skráðar frátektir');

        return this.http
            .get<HttpStatus<ExposedListAzureEnvironmentReservationRes[]>>(`${environment.localApi}azuredevops/environments/reservations/${environmentName}`, this.httpRequestHelper.getRequestOptionsAuth())
            .pipe(
                map((res: HttpStatus<ExposedListAzureEnvironmentReservationRes[]>) => res.returnItem),
                catchError((error) => {
                    HttpError(this.alertsService, this.router, error, '', '', '', '');
                    throw error;
                }),
                finalize(() => {
                    this.loaderService.changeActiveLoaders(-1);
                })
            );
    }

    public deleteAzureEnvironmentReservation(reservationId: number): Observable<boolean> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Eyði frátekt');

        return this.http
            .delete<HttpStatus<boolean>>(`${environment.localApi}azuredevops/environments/reservations/${reservationId}`, this.httpRequestHelper.getRequestOptionsAuth())
            .pipe(
                map((res: HttpStatus<boolean>) => res.returnItem),
                catchError((error) => {
                    HttpError(this.alertsService, this.router, error, '', '', '', '');
                    throw error;
                }),
                finalize(() => {
                    this.loaderService.changeActiveLoaders(-1);
                })
            );
    }
}